import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import "./assets/style.css";

const app = createApp(App).use(router).use(i18n);

// Reveal-on-scroll directive: adds `.in` once the element intersects.
const revealObserver =
  typeof IntersectionObserver !== "undefined"
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
      )
    : null;

app.directive("reveal", {
  mounted(el, binding) {
    el.classList.add("reveal");
    const delay = binding.value;
    if (delay) el.classList.add(`reveal-delay-${delay}`);
    if (revealObserver) {
      revealObserver.observe(el);
    } else {
      el.classList.add("in");
    }
  },
  unmounted(el) {
    if (revealObserver) revealObserver.unobserve(el);
  },
});

app.mount("#app");
